<template>
  <CSidebar 
    fixed 
    size="sm"
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('coreui/set', ['sidebarShow', value])"
  >
  <!--
    <CSidebarBrand class="d-md-down-none" to="/">
      <CIcon 
        class="c-sidebar-brand-full" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        viewBox="0 0 556 134"
      />
      <CIcon 
        class="c-sidebar-brand-minimized" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        viewBox="0 0 110 134"
      />
    </CSidebarBrand>
    -->

    <CRenderFunction flat :content-to-render="activeNav"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('coreui/set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from './_nav'

export default {
  name: 'TheSidebar',
  data() {
    return {
      nav,
    }
  },
  computed: {
    activeNav: function() {
      return [{
        _name: 'CSidebarNav',
        _children: this.nav[0]._children.filter(item=>{
          if(item.roles && item.roles.length > 0) { 
            const intersection = item.roles.filter( role => this.$store.state.auth.roles.includes(role));
            return intersection.length > 0
          } else {
            return true;
          }
        })
      }]
    },
    show () {
      return this.$store.state.coreui.sidebarShow 
    },
    minimize () {
      return this.$store.state.coreui.sidebarMinimize 
    }
  }
}
</script>
